import type { OnboardingUserRole } from "../components/services/requests";

/** Fallback when GET /OnBoarding/userroles is unavailable. */
export const DEFAULT_USER_ROLES: OnboardingUserRole[] = [
  { id: 1, code: "customer", name: "Customer", sortOrder: 1 },
  {
    id: 2,
    code: "implementationTeam",
    name: "Implementation Team",
    sortOrder: 2,
  },
  { id: 3, code: "tpm", name: "TPM", sortOrder: 3 },
  { id: 4, code: "admin", name: "Admin", sortOrder: 50 },
];
